import { useCallback, useEffect, useState } from 'react'
import { usePatient } from '../context/PatientContext'
import * as svc from '../services/activitiesService'

export function useActivitiesList() {
  const { currentProfile } = usePatient()
  const [items, setItems] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const refresh = useCallback(async () => {
    if (!currentProfile) {
      setItems(null)
      setLoading(false)
      return
    }
    setLoading(true)
    setError(null)
    try {
      const data = await svc.listActive(currentProfile)
      setItems(data)
    } catch (e) {
      setError(e)
    } finally {
      setLoading(false)
    }
  }, [currentProfile])

  useEffect(() => {
    setItems(null)
    refresh()
  }, [refresh])

  const complete = useCallback(
    async (id, body) => {
      await svc.complete(currentProfile, id, body)
      await refresh()
    },
    [currentProfile, refresh],
  )

  return { items, loading, error, refresh, complete }
}

export function useActivityHistory(id) {
  const { currentProfile } = usePatient()
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)

  const refresh = useCallback(async () => {
    if (!currentProfile || !id) return
    setLoading(true)
    try {
      const data = await svc.history(currentProfile, id)
      setItems(data)
    } finally {
      setLoading(false)
    }
  }, [currentProfile, id])

  useEffect(() => {
    refresh()
  }, [refresh])

  return { items, loading, refresh }
}
